import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedCareer: cacheLs.get_career()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
